import Table from 'antd/lib/table';
import React from 'react';
import { makeNumberColumnProps } from './column-props';
function makeTableColumns(columnDefinitions, columnPropsDict) {
    return columnDefinitions.map((columnDefinition) => {
        const providedProps = columnPropsDict?.[columnDefinition.id];
        let defaultProps = {};
        defaultProps.title = columnDefinition.id;
        switch (columnDefinition.type) {
            case 'number':
                defaultProps = makeNumberColumnProps(defaultProps);
                break;
            default:
        }
        return {
            ...defaultProps,
            ...providedProps,
            key: columnDefinition.id,
            dataIndex: columnDefinition.id,
        };
    });
}
export const ChartTable = (props) => {
    const columnDefinitions = props.chartData.columnDefinitions;
    const columns = makeTableColumns(columnDefinitions, props.columnProps);
    const datasetIndex = props.datasetIndex ?? 0;
    const dataSet = props.chartData.dataSets[datasetIndex];
    return (React.createElement(Table, { columns: columns, dataSource: dataSet.rows, pagination: false, rowKey: columnDefinitions[0].id, size: "small", ...props.tableProps }));
};
